import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get } from 'lodash';
import { Breadcrumbs, HelmetWrapper, TYPES } from 'sarsaparilla';
import QuestionnaireContainer from '../components/questionnaire/QuestionnaireContainer';
import * as pActions from '../actions/permit';
import { MT_WHITNEY_PERMIT_ID } from '../utils/inyoUtils';

const propTypes = {
  match: TYPES.MATCH,
  permit: PropTypes.object,
  pActions: PropTypes.object
};

const defaultProps = {};

export class QuestionnairePage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      permitId: props.match.params.permitId
    };
  }

  componentDidMount() {
    const permitId = this.state.permitId;
    this.props.pActions.fetchPermit(permitId)
      .then((permit) => {
        const recAreaId = get(permit, "recareas[0]");
        const recAreaName = get(this.props, "recarea.[0].name");
        if (recAreaId && !recAreaName) {
          this.props.pActions.fetchRecarea(recAreaId);
        }
      });
    this.props.pActions.fetchLotteries(MT_WHITNEY_PERMIT_ID)
  }

  render() {
    const recAreaName = get(this.props, "recarea[0].name", "");
    const recAreaId = get(this.props, "recarea[0].entity_id", "");
    const { permit } = this.props;
    const { name, id } = permit;

    const path = [
      { title: 'Home', url: '/' },
      { title: recAreaName, url: `/camping/gateways/${recAreaId}` },
      { title: name, url: `/permits/${id}` },
      { title: 'Walk Me Through' }
    ];

    return (
      <div className="inyonwhitney">
        <HelmetWrapper title={`Which Permit Do I Need For ${name}?`} />
        <div className="permit-content-outer-wrap">
          <div className="permit-content-wrap">
            <div className="rec-nested-wrap">
              <div className={'rec-grid-12-12'}>
                <Breadcrumbs
                  path={path} />
              </div>
              <QuestionnaireContainer
                pActions={this.props.pActions}
                lotteries={this.props.lotteries}
                permit={this.props.permit} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

QuestionnairePage.displayName = 'QuestionnairePage';
QuestionnairePage.propTypes = propTypes;
QuestionnairePage.defaultProps = defaultProps;

function select(state) {
  return {
    permit: state.inyonwhitney.permit.result,
    recarea: state.inyonwhitney.permit.recarea,
    lotteries: state.inyonwhitney.lotteries
  };
}

function mapDispatchToProps(dispatch) {
  return {
    pActions: bindActionCreators(pActions, dispatch)
  };
}

export default connect(select, mapDispatchToProps)(QuestionnairePage);
